import { hasGroupColumns } from '../types';
import type { TableHeaderProps, TableRowData } from '../types';
import { GroupedHeader } from './TableHeader/GroupedHeader';
import { SingleRowHeader } from './TableHeader/SingleRowHeader';

/**
 * Table header component
 * Supports both standard columns and grouped columns.
 *
 * When any column has grouped headers, renders two header rows:
 * - Row 1: Grouping headers (group columns only)
 * - Row 2: Main headers (leaf columns with actions)
 *
 * When no grouped columns exist, renders a single row (backwards compatible).
 */
export function TableHeader<TRow extends TableRowData>(
  props: TableHeaderProps<TRow>
) {
  if (!hasGroupColumns(props.columns)) {
    return <SingleRowHeader {...props} />;
  }

  return <GroupedHeader {...props} />;
}
